const baseURL = 'https://resto.smarttechsc.com/';

export default baseURL;
